export default function getCurrentBreakpoint(breakpoints, windowWidth) {
    let currentBreakpoint = null;

    Object.entries(breakpoints).forEach(([breakpoint, value]) => {
        if (windowWidth >= breakpoint) {
            currentBreakpoint = value;
        }
    });

    return currentBreakpoint;
}
